// Retired item-type ids → live replacement. Persistence (world_items, bag,
// equipped weapon) can outlive a content rename; resolve through here before
// treating a string as an ItemType. DOM-free — server + client share it.
//
// Add a row when you rename or replace a content/items/<id>.json type id.
// Pair with a migrations/NNNN_*.sql UPDATE so the DB converges (this file is
// the runtime belt for in-memory / pre-migration boots).

/** Old type id → new type id (must exist in content after `bun run gen`). */
export const ITEM_TYPE_RENAMES: Readonly<Record<string, string>> = {
  lance: "spear",
  /** Campfire fuel migrated to species logs (tree-cutting); default oak. */
  firewood: "oak-logs",
};

/** Apply renames only — does not check the type still exists in content. */
export function renameItemType(raw: string): string {
  return ITEM_TYPE_RENAMES[raw] ?? raw;
}
